var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blkt"},[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"txt1"},[_vm._v(_vm._s(_vm.item.tit))]),_c('div',{staticClass:"txt2"},[_vm._v(_vm._s(_vm.item.subtit))])])])}
var staticRenderFns = []

export { render, staticRenderFns }